import { Deserializable } from '../../protocols/deserializable';
import { EmployerPlanDesignatedUnitVersion } from './employer-plan-designated-unit-version';

export class IpCreateDesignatedUnitRequest implements Deserializable {
  public designatedUnitTypeId!: number;
  public remittanceFrequencyTypeId!: number;
  public employerPlanId!: number;
  public unitName!: string;
  public clientUnitId!: string;
  public version!: EmployerPlanDesignatedUnitVersion;

  onDeserialize(): void {}
}
